import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';
/**
 * FooterProps.
 *
 * @param {FooterProps} props footer's props
 * @returns {React.FC<FooterProps>} Footer.
 */
var CleanFooter = function (options) {
    return (React.createElement(Grid, { container: true, className: options.className },
        options.logoContent && (React.createElement(Grid, { item: true, xs: 12, className: 'item' },
            React.createElement("div", { className: 'center' }, options.logoContent))),
        React.createElement(Grid, { item: true, xs: 12, sm: 6, className: 'item' },
            React.createElement("div", { className: 'center' }, options.terms)),
        React.createElement(Grid, { item: true, xs: 12, sm: 6, className: 'item' },
            React.createElement("div", { className: 'center' }, options.conditions)),
        options.children && (React.createElement(Grid, { item: true, xs: 12, className: 'item' }, options.children))));
};
export var Footer = styled(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(CleanFooter, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: #eeeeef;\n  color: white;\n  min-height: 100px;\n  position: relative;\n  padding: 20px 0;\n\n  .item {\n    .center {\n      text-align: center;\n      img {\n        display: block;\n        margin-left: auto;\n        margin-right: auto;\n      }\n    }\n  }\n"], ["\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: #eeeeef;\n  color: white;\n  min-height: 100px;\n  position: relative;\n  padding: 20px 0;\n\n  .item {\n    .center {\n      text-align: center;\n      img {\n        display: block;\n        margin-left: auto;\n        margin-right: auto;\n      }\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=Footer.js.map